import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    permissions: [],
    sites: [],
    userInfo: null
  },
  getters: {
    getPermissions: (state) => state.permissions,
    getUserInfo: (state) => state.userInfo,
    hasMyConnectAccess: (state) => {
      return state.permissions.some((p) => p.name === 'myconnect');
    }
  },
  mutations: {
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload;
    },
    SET_SITES(state, payload) {
      state.sites = payload;
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    }
  },
  actions: {
    async fetchPermissions({ commit, state }) {
      if (state.permissions.length > 0) return { permissions: state.permissions };

      try {
        const response = await Vue.prototype.$http2.get('/api/user/permissions');
        const { permissions, sites } = response.data.data;

        commit('SET_PERMISSIONS', permissions);
        commit('SET_SITES', sites);

        const userInfo = Vue.$cookies.get('userInfo');
        if (userInfo) commit('SET_USER_INFO', userInfo);

        return { permissions, sites };
      } catch (error) {
        console.error('Erro ao buscar permissões:', error);
        throw error;
      }
    }
  }
};
